<div class="h-full">
    <h2 class="sr-only">Contacts</h2>
    <div class="card h-full">
        <dl class="flex flex-wrap">
            <div *ngIf="company" class="w-full flex items-start justify-between pl-6 pt-6 pr-6">
                <div class="flex items-center">
                    <img *ngIf="company?.logo_url" [src]="company?.logo_url || 'https://ui-avatars.com/api/?background=FFA500&color=fff&rounded=true&name='+company?.name+'&format=svg&size=128'"
                         (error)="onImageError($event)"
                         class="h-12 w-12 rounded-lg">
                    <div class="ml-3">
                        <h2 class="text-xl font-semibold">{{ company?.name }}</h2>
                        <p class="text-sm !text-secondary dark:!text-primary-200">{{ company?.city ? company?.city + ',' : '' }} {{ company?.state ? company?.state + ',' : '' }} {{ company?.country }}</p>
                    </div>
                </div>
                <button type="button" (click)="openEditContactModal()" class="flex-shrink-0 text-secondary hover:opacity-90">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                    <path d="m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" />
                  </svg>
                </button>
            </div>

            <!-- Website -->
            <div *ngIf="company?.website" class="flex items-center w-full flex-none gap-x-4 border-t border-violet-50 dark:border-[#3c4377] px-6 pt-4 mt-6">
                <dt class="flex-none">
                  <span class="sr-only">Website</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-secondary-900 dark:text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418" />
                  </svg>
                </dt>
                <dd class="text-sm font-medium leading-6 text-gray-900 dark:text-white">
                    <h3 class="text-lg font-[400]">Website</h3>
                </dd>
            </div>

            <!-- Website URL -->
            <div *ngIf="company?.website" class="mt-2 flex w-full flex-none gap-x-4 px-4">
                <dt class="w-5 max-w-5 flex-shrink-0">
                    <span class="sr-only">Website</span>
                </dt>
                <dd class="text-sm leading-6 text-blue-500 dark:!text-[#91a7ff] break-all flex-1">
                    <a href="{{ company?.website }}" target="_blank" class="hover:underline">{{ company?.website }}</a>
                </dd>
            </div>

            <!-- Blog -->
            <div *ngIf="company?.blog" class="mt-2 flex w-full flex-none gap-x-4 px-4">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <span class="sr-only">Blog</span>
              </dt>
              <dd class="text-sm leading-6 text-blue-500 dark:!text-[#91a7ff] break-all flex-1">
                <a href="{{ company?.blog }}" target="_blank" class="hover:underline">{{ company?.blog }}</a>
              </dd>
            </div>
            <!-- / Website -->

            <!-- Phone Numbers -->
            <div *ngIf="hasPhoneNumbers" class="flex items-center w-full flex-none gap-x-4 border-t border-violet-50 dark:border-[#3c4377] px-6 pt-4 mt-4">
              <dt class="flex-none">
                <span class="sr-only">Phone numbers</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-secondary-900 dark:text-white">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                </svg>
              </dt>
              <dd class="text-sm font-medium leading-6 text-gray-900 dark:text-white">
                <h3 class="text-lg font-[400]">Phone numbers</h3>
              </dd>
            </div>

            <div *ngFor="let phoneNumber of uniquePhoneNumbers.slice(0, displayLimit); let i = index" class="mt-2 flex w-full flex-none gap-x-4 px-4">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <span class="sr-only">Phone</span>
              </dt>
              <dd class="text-sm leading-6 text-blue-500 !font-normal dark:!text-[#91a7ff] break-all flex-1">
                <a href="tel:{{ phoneNumber }}" class="hover:underline">{{ phoneNumber }}</a>
              </dd>
            </div>

            <!-- Display more button for phone numbers -->
            <div *ngIf="uniquePhoneNumbers.length > displayLimit" class="mt-2 flex w-full flex-none gap-x-4 px-4">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <span class="sr-only">More phones</span>
              </dt>
              <dd class="text-xs leading-6 flex-1">
                <button
                  type="button"
                  (click)="showAllPhoneNumbers()"
                  class="text-xs text-blue-500 dark:text-[#91a7ff] font-medium hover:underline transition-colors duration-200">
                  Display more ({{ uniquePhoneNumbers.length - displayLimit }} more)
                </button>
              </dd>
            </div>
            <!-- / Phone Numbers -->

            <!-- Email Addresses -->
            <div *ngIf="hasEmails" class="flex items-center w-full flex-none gap-x-4 border-t border-violet-50 dark:border-[#3c4377] px-6 pt-4 mt-4">
              <dt class="flex-none">
                <span class="sr-only">Email addresses</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-secondary-900 dark:text-white">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                </svg>
              </dt>
              <dd class="text-sm font-medium leading-6 text-gray-900 dark:text-white">
                <h3 class="text-lg font-[400]">Email addresses</h3>
              </dd>
            </div>

            <div *ngFor="let email of uniqueEmails.slice(0, displayLimit)" class="mt-2 flex w-full flex-none gap-x-4 px-4">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <span class="sr-only">Email</span>
              </dt>
              <dd class="text-sm leading-6 text-blue-500 !font-normal dark:!text-[#91a7ff] break-all flex-1">
                <a href="mailto:{{ email }}" class="hover:underline">{{ email }}</a>
              </dd>
            </div>

            <!-- Display more button for emails -->
            <div *ngIf="uniqueEmails.length > displayLimit" class="mt-2 flex w-full flex-none gap-x-4 px-4">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <span class="sr-only">More emails</span>
              </dt>
              <dd class="text-xs leading-6 flex-1">
                <button
                  type="button"
                  (click)="showAllEmails()"
                  class="text-xs text-blue-500 dark:text-[#91a7ff] font-medium hover:underline transition-colors duration-200">
                  Display more ({{ uniqueEmails.length - displayLimit }} more)
                </button>
              </dd>
            </div>
            <!-- / Email Addresses -->

            <!-- Social profiles -->
            <div *ngIf="company?.social_media?.linkedin_url || company?.social_media?.facebook_url || company?.social_media?.twitter_url" class="flex items-center w-full flex-none gap-x-4 border-t border-violet-50 dark:border-[#3c4377] px-6 pt-4 mt-4">
                <dt class="flex-none">
                  <span class="sr-only">Social profiles</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-secondary-900 dark:text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                  </svg>
                </dt>
                <dd class="text-sm font-medium leading-6 text-gray-900 dark:text-white">
                    <h3 class="text-lg font-[400]">Social profiles</h3>
                </dd>
            </div>

            <!-- Facebook URL -->
            <div *ngIf="company?.social_media?.facebook_url" class="flex items-center mt-2 w-full gap-x-4 px-6">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <svg class="h-5 w-5 fill-[#0766ff]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd"></path>
                </svg>
              </dt>
              <dd class="text-sm leading-6 text-blue-500 dark:!text-[#91a7ff] break-all flex-1">
                <a href="{{ company?.social_media?.facebook_url }}" target="_blank" class="hover:underline">{{ company?.social_media?.facebook_url }}</a>
              </dd>
            </div>

            <!-- Linkedin URL -->
            <div *ngIf="company?.social_media?.linkedin_url" class="flex items-center mt-2 w-full gap-x-4 px-6">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <svg viewBox="0 0 14 13" fill="none" class="h-5 w-5 fill-[#0b66c2]">
                  <path d="M12.25 0.625C12.7148 0.625 13.125 1.03516 13.125 1.52734V12C13.125 12.4922 12.7148 12.875 12.25 12.875H1.72266C1.25781 12.875 0.875 12.4922 0.875 12V1.52734C0.875 1.03516 1.25781 0.625 1.72266 0.625H12.25ZM4.56641 11.125V5.30078H2.76172V11.125H4.56641ZM3.66406 4.48047C4.23828 4.48047 4.70312 4.01562 4.70312 3.44141C4.70312 2.86719 4.23828 2.375 3.66406 2.375C3.0625 2.375 2.59766 2.86719 2.59766 3.44141C2.59766 4.01562 3.0625 4.48047 3.66406 4.48047ZM11.375 11.125V7.92578C11.375 6.36719 11.0195 5.13672 9.1875 5.13672C8.3125 5.13672 7.71094 5.62891 7.46484 6.09375H7.4375V5.30078H5.71484V11.125H7.51953V8.25391C7.51953 7.48828 7.65625 6.75 8.61328 6.75C9.54297 6.75 9.54297 7.625 9.54297 8.28125V11.125H11.375Z" />
                </svg>
              </dt>
              <dd class="text-sm leading-6 text-blue-500 dark:!text-[#91a7ff] break-all flex-1">
                <a href="{{ company?.social_media?.linkedin_url }}" target="_blank" class="hover:underline">{{ company?.social_media?.linkedin_url }}</a>
              </dd>
            </div>

            <!-- Twitter URL -->
            <div *ngIf="company?.social_media?.twitter_url" class="flex items-center mt-2 w-full gap-x-4 px-6">
              <dt class="w-5 max-w-5 flex-shrink-0">
                <svg class="h-5 w-5 text-secondary-900 dark:text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
                </svg>
              </dt>
              <dd class="text-sm leading-6 text-blue-500 dark:!text-[#91a7ff] break-all flex-1">
                <a href="{{ company?.social_media?.twitter_url }}" target="_blank" class="hover:underline">{{ company?.social_media?.twitter_url }}</a>
              </dd>
            </div>
            <!-- / Social profiles -->

        </dl>
        <div class="pb-6"></div>
    </div>
</div>
